
import React from 'react';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import { useAuth } from '@/hooks/useAuth';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle, Shield } from 'lucide-react';
import AuthTestSuite from './AuthTestSuite';
import DatabaseTestSuite from './DatabaseTestSuite';
import SystemHealthMonitor from './SystemHealthMonitor';
import UserManagementTools from './UserManagementTools';

const TestDashboard = () => {
  const { user: internalUser } = useInternalAuth();
  const { user: supabaseUser, profile } = useAuth();

  // Determine user role and check admin access
  const userRole = profile?.role || internalUser?.role;
  const isAdmin = userRole === 'admin';

  // If not admin, show access denied
  if (!isAdmin) {
    return (
      <Card className="bg-red-900/20 border-red-500">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-red-400">
            <AlertTriangle className="h-5 w-5" />
            Access Denied
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-red-300">
            This testing dashboard is restricted to administrator accounts only. 
            Your current role ({userRole}) does not have access to these administrative tools.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <Card className="bg-gray-800 border-gray-700">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-white">
            <Shield className="h-5 w-5 text-sports-green" />
            Administrator System Testing Dashboard
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-300">
            Welcome, {internalUser?.username || profile?.username}! You have admin access to system testing tools.
          </p>
        </CardContent>
      </Card>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <AuthTestSuite />
        <DatabaseTestSuite />
        <SystemHealthMonitor />
        <UserManagementTools />
      </div>
    </div>
  );
};

export default TestDashboard;
